import "../../components/button/StyledButton.css"
import AddEcomForm from "components/addEcomForm/AddEcomForm";
import { useGetEcomLatestQuery } from "api/api";
import * as z from "zod";
import { createEcomFieldValidation } from "./helpers";

const AddEcomConcretePage = () => {
  const { data: latestEcomData = [] } = useGetEcomLatestQuery();
  const filteredEcomData = latestEcomData['ECOMData'].filter(data => data.material_category === 'Concrete');
  const materialMapping = filteredEcomData.reduce((accumulator, material) => {
    accumulator[material.material_type] = material.a1_a3_carbon_factor;
    return accumulator;
  }, {});

  const inputLabels = [
    { name: "2,500 PSI", label: "2,500 PSI", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['2500 PSI'], component: "FormTextField" },
    { name: "3,000 PSI", label: "3,000 PSI", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['3000 PSI'], component: "FormTextField" },
    { name: "4,000 PSI", label: "4,000 PSI", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['4000 PSI'], component: "FormTextField" },
    { name: "5,000 PSI", label: "5,000 PSI", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['5000 PSI'], component: "FormTextField" },
    { name: "6,000 PSI", label: "6,000 PSI", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['6000 PSI'], component: "FormTextField" },
    { name: "8,000 PSI", label: "8,000 PSI", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['8000 PSI'], component: "FormTextField" },
    { name: "3,000 PSI LW", label: "3,000 PSI LW", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['3000 PSI LW'], component: "FormTextField" },
    { name: "4,000 PSI LW", label: "4,000 PSI LW", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['4000 PSI LW'], component: "FormTextField" },
    { name: "5,000 PSI LW", label: "5,000 PSI LW", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['5000 PSI LW'], component: "FormTextField" },
  ];

  const inputNames = inputLabels.map((input) => input.name)

  const schema = z.object(
    Object.fromEntries(
      inputNames.map(key => [key, createEcomFieldValidation(key)])
    )
  );

  return (
    <AddEcomForm
      title="Concrete"
      inputLabels={inputLabels}
      stage={2}
      validationSchema={schema}
    />
  );
}


export default AddEcomConcretePage;